export default __webpack_public_path__ + "static/contour-bg-2bb5c6821ce97bba7fbc81e507be19b8.gif";